const forceHttps = (str) => {
    return str.replace("http://", "https://");
};

export default forceHttps;
